import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { Input, FormFeedback } from 'reactstrap';


class Delete extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        id: PropTypes.func.isRequired,
    }

    render() {
        return (
            <ParadigmaModal
                getUrl={api.imputaciones.titulosSeparaciones.delete}
                postUrl={api.imputaciones.titulosSeparaciones.delete}
                onSubmit={() => this.props.onSubmit()}
                id={this.props.id}
                buttonTitle={"Eliminar Título"}
                successMessage={"El parámetro ha sido eliminado con éxito."}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Eliminar Título"}
                buttonIcon={"fa fa-trash fa-lg"}
                className={"ui-modal-dialog"}
                saveButton={true}
                closeButton={true}
                danger={true}
                buttonClass={"btn-danger"}
                saveButtonLabel={"Eliminar"}
            >
                <div className="ui-form">
                    <section className="ui-section-block">
                        <h5 className="ui-section-label">Parámetro seleccionado</h5>
                        <div className="ui-row-1">
                            <div className="ui-field">
                                <label>Nombre</label>
                                <Input type="text" name="nombre" disabled={true}></Input>
                                <FormFeedback className="col-12"></FormFeedback>
                            </div>
                        </div>
                    </section>
                    <div className="ui-alert ui-alert-danger mt-3 mb-0">
                        <i className="fa fa-trash" aria-hidden="true"></i>
                        <span>Esta acción eliminará el parámetro seleccionado.</span>
                    </div>
                </div>
            </ParadigmaModal>
        );
    }
}

export default Delete;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/TitulosSeparaciones/Delete.js